module.exports = __webpack_public_path__ + "29a8966effee4088384bcf2434acae6a.svg";